export class LoggingAnalyticsHandler {
  trackPageView(url) {
    console.log('Analytics page view:', url); // eslint-disable-line no-console
  }

  trackSignUp(details) {
    console.log('Analytics sign up:', details); // eslint-disable-line no-console
  }
}

// Google Analytics 4 (GA4) using gtag.js script, which is included in util/includeScripts.js
export class GoogleAnalyticsHandler {
  trackPageView(canonicalPath, previousPath) {
    // GA4 property. Manually send page_view events
    // https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
    // Note 1: You should turn "Enhanced measurement" off.
    //         It attaches own listeners to elements and that breaks in-app navigation.
    // Note 2: If previousPath is null (just after page load), gtag script sends page_view event automatically.
    //         Only in-app navigation needs to be sent manually from SPA.
    // Note 3: Timeout is needed because gtag script picks up <title>,
    //         and location change event happens before initial rendering.
    if (previousPath && window.gtag) {
      window.setTimeout(() => {
        window.gtag('event', 'page_view', {
          page_path: canonicalPath,
        });
      }, 300);
    }
  }

  // Drivelo: GA4's recommended sign_up event, sent once the account exists.
  // Mark it as a key event in GA4 and base the Google Ads "Sign up"
  // conversion on it, instead of on page views of /signup.
  trackSignUp({ method, userType }) {
    if (window.gtag) {
      window.gtag('event', 'sign_up', { method, user_type: userType });
    }
  }
}
